import React from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { Typography } from '../../../ui';
import { getAppConfig } from '../../selectors/basketSelectors';
import { AboutMyData } from '../SecureWarningModal/AboutMyData';

type Props = {
  isPaymentCopyRight?: boolean;
} & StateProps;

const FlipDishCopyRight = ({ translate }: Props) => {
  return (
    <div>
      <AboutMyData style={{ color: '#888888' }} translate={translate} />
    </div>
  );
};

type StateProps = ReturnType<typeof mapStateToProps>;
const mapStateToProps = (s) => {
  const config = getAppConfig(s);
  return {
    translate: getTranslate(s.locale)
  };
};

export default connect(mapStateToProps)(FlipDishCopyRight);
